import React from "react";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import "../styles/modalStyles.css";
import { css } from "@emotion/react";
import MoonLoader from "react-spinners/MoonLoader";

const override = css`
  position: abolute;
  left: vh;
`;

const loadingColor = "#355efc";

const ConfirmationModal = (props) => {
  const { title, isOpen, onClose, isLoading } = props;

  // useEffect(() => {
  //   console.log("birthed");
  // }, []);

  // useEffect(() => {
  //   console.log("loading: ", isLoading);
  // }, [isLoading]);

  return (
    <Modal open={isOpen} onClose={onClose} style={{}} className="add-modal">
      <div className="add-modal-content" style={{ height: "15vh" }}>
        {!isLoading ? (
          <>
            <h3>{title}</h3>
            <div className="add-name">
              <Button style={{ marginLeft: "15px" }} color="primary" onClick={onClose}>
                Continue
              </Button>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "13vh",
              }}
            >
              <MoonLoader color={loadingColor} loading={isLoading} css={override} style={{ marginLeft: "auto auto" }} />
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
